// Each row owns its file, preview and signed blob ID. Neither names nor the
// order in which requests finish are used to associate uploads with rows.
export class NytieUploads {
  constructor(element, uploadFile) {
    this.element = element;
    this.uploadFile = uploadFile;
    this.form = element.closest("form");
    this.input = element.querySelector("[data-upload-input]");
    this.choose = element.querySelector("[data-upload-choose]");
    this.list = element.querySelector("[data-upload-files]");
    this.message = element.querySelector("[data-upload-message]");
    this.labels = JSON.parse(element.dataset.labels);
    this.nextIndex = Number(element.dataset.nextIndex);
    this.lockedButtons = new Set();
    this.dragDepth = 0;

    this.choose.addEventListener("click", () => this.input.click());
    this.input.addEventListener("change", () => {
      this.addFiles(this.input.files);
      this.input.value = "";
    });
    element.addEventListener("dragenter", (event) => {
      event.preventDefault();
      this.dragDepth += 1;
      this.choose.classList.add("is-dragover");
    });
    element.addEventListener("dragover", (event) => event.preventDefault());
    element.addEventListener("dragleave", () => {
      this.dragDepth = Math.max(0, this.dragDepth - 1);
      if (!this.dragDepth) this.choose.classList.remove("is-dragover");
    });
    element.addEventListener("drop", (event) => {
      event.preventDefault();
      this.dragDepth = 0;
      this.choose.classList.remove("is-dragover");
      this.addFiles(event.dataTransfer.files);
    });
    this.list.addEventListener("click", (event) => {
      const remove = event.target.closest("[data-upload-remove]");
      if (remove) {
        this.remove(remove.closest("li"));
        this.choose.focus();
      }
    });
    this.form.addEventListener("submit", (event) => {
      if (this.blocked()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.message.textContent = this.labels.pending;
      }
    }, true);
    window.addEventListener("pagehide", () => {
      this.list.querySelectorAll("[data-preview-url]").forEach((row) => URL.revokeObjectURL(row.dataset.previewUrl));
    });
  }

  blocked() {
    return Boolean(this.list.querySelector('[data-upload-state="uploading"], [data-upload-state="error"]'));
  }

  update() {
    const blocked = this.blocked();
    if (blocked) {
      this.form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((button) => {
        if (!button.disabled) {
          this.lockedButtons.add(button);
          button.disabled = true;
        }
      });
    } else {
      this.lockedButtons.forEach((button) => { button.disabled = false; });
      this.lockedButtons.clear();
    }
    this.message.textContent = blocked ? this.labels.pending : "";
  }

  remove(row) {
    row.dataset.uploadState = "removed";
    if (row.dataset.previewUrl) URL.revokeObjectURL(row.dataset.previewUrl);
    row.remove();
    this.update();
  }

  addFiles(files) {
    Array.from(files).forEach((file) => this.addFile(file));
  }

  async addFile(file) {
    const index = this.nextIndex++;
    const row = document.createElement("li");
    row.className = "nytie-uploads__file";
    row.dataset.uploadState = "uploading";
    if (file.type.startsWith("image/")) {
      const preview = document.createElement("img");
      row.dataset.previewUrl = URL.createObjectURL(file);
      preview.src = row.dataset.previewUrl;
      preview.alt = "";
      preview.className = "nytie-uploads__preview";
      row.append(preview);
    }
    const name = document.createElement("span");
    name.textContent = file.name;
    const status = document.createElement("span");
    status.dataset.uploadStatus = "";
    status.textContent = this.labels.uploading;
    const remove = document.createElement("button");
    remove.type = "button";
    remove.dataset.uploadRemove = "";
    remove.textContent = this.labels.remove;
    row.append(name, status, remove);
    this.list.append(row);
    this.update();

    try {
      const maxSize = Number(this.element.dataset.maxSize);
      if (maxSize && file.size > maxSize) throw new Error(this.labels.failed);
      const signedId = await this.uploadFile(file, this.element.dataset);
      if (row.dataset.uploadState === "removed") return;
      Object.entries({ file: signedId, title: file.name }).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `${this.element.dataset.resourceName}[add_attachments][${index}][${key}]`;
        input.value = value;
        row.append(input);
      });
      row.dataset.uploadState = "ready";
      status.textContent = this.labels.ready;
    } catch (error) {
      if (row.dataset.uploadState === "removed") return;
      row.dataset.uploadState = "error";
      status.textContent = error.message || this.labels.failed;
    } finally {
      this.update();
    }
  }
}
